import { Tooltip } from '@mui/material';
import type { Role } from '@repo/api-gw-sdk';

import type { PermissionDescriptor } from '@/contexts/permissions';

import { getAssignedDataAccessRule } from './utils';

import { Icon } from '../shared/icon';

export const PermissionIcon = ({
  isPermissionAuthorized,
  editMode,
  permission,
  role,
}: {
  permission: PermissionDescriptor;
  role: Role;
  isPermissionAuthorized: boolean;
  editMode?: boolean;
}) => {
  const assignedDataAccessRule = getAssignedDataAccessRule(permission, role);

  return (
    <Tooltip title={editMode ? 'Access level' : undefined}>
      <Icon
        iconClass={
          assignedDataAccessRule
            ? 'material-symbols-rule-rounded'
            : isPermissionAuthorized
              ? 'material-symbols-check'
              : 'material-symbols-close-rounded'
        }
        sx={{
          ...(editMode
            ? {
                cursor: 'pointer',
                backgroundColor: assignedDataAccessRule
                  ? '#FFE8DB'
                  : isPermissionAuthorized
                    ? 'var(--mui-palette-success-opacity)'
                    : 'var(--mui-palette-error-opacity)',
              }
            : {}),

          i: {
            color: assignedDataAccessRule
              ? '#EC6924'
              : isPermissionAuthorized
                ? 'var(--mui-palette-success-main)'
                : 'var(--mui-palette-error-main)',
          },
        }}
      />
    </Tooltip>
  );
};
